<template>
  <transition name="fade">
    <div class="mod-req-app">
      <div class="mod-req-app-container">
        <div class="btn-close" @click="closeModal()">
          X
        </div>
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            BLOCK VENDOR
          </div>
        </div>
        <div>Nama Vendor</div>
        <div class="half-input-wrapper">
          <v-select
            class="style-chooser"
            placeholder="Cari Vendor"
            label="nama_vendor"
            :options="vendors"
            v-model="choosedVendor"
            @search="typingVendor"
          />
        </div>
        <div>
          <div>Bisnis Unit</div>
          <div class="flex-space-between">
            <div>
              <input
                type="radio"
                value="2"
                v-model="choosedBisnis"
                class="mr10"
                :disabled="gemsReady"
              />
              <label>GEMS</label>
            </div>
            <div>
              <input
                type="radio"
                value="1"
                v-model="choosedBisnis"
                class="mr10"
                :disabled="bceReady"
              />
              <label>BCE</label>
            </div>
            <div>
              <input
                type="radio"
                value="3"
                v-model="choosedBisnis"
                class="mr10"
                :disabled="bkesReady"
              />
              <label>BKES</label>
            </div>
          </div>
        </div>
        <div v-if="bisnis_unit == 2">Detail Company GEMS</div>
        <div class="half-input-wrapper" v-if="bisnis_unit == 2">
          <v-select
            class="style-chooser"
            placeholder="Cari GEMS"
            label="nama_perusahaan"
            :reduce="option => option.kode"
            :options="gems"
            v-model="choosedGems"
          />
        </div>
        <div v-if="bisnis_unit == 1">Detail Company BCE</div>
        <div class="half-input-wrapper" v-if="bisnis_unit == 1">
          <v-select
            class="style-chooser"
            placeholder="Cari BCE"
            label="nama_perusahaan"
            :reduce="option => option.kode"
            :options="bc"
            v-model="choosedBc"
          />
        </div>
        <div v-if="bisnis_unit == 3">Detail Company BKES</div>
        <div class="half-input-wrapper" v-if="bisnis_unit == 3">
          <v-select
            class="style-chooser"
            placeholder="Cari BKES"
            label="nama_perusahaan"
            :reduce="option => option.kode"
            :options="bkes"
            v-model="choosedBkes"
          />
        </div>
        <div>
          <div>Lampiran</div>
          <label class="btn btn-default btn-file">
            <i class="fas fa-upload"></i> {{ theFileName }}
            <input
              type="file"
              style="display: none;"
              @change="fileChangeHandler"
            />
          </label>
        </div>
        <div>
          <div>Catatan</div>
          <input type="text" class="input-100" v-model="note" />
        </div>
      </div>
      <div class="one-btn-center">
        <div class="btn-big">
          <div class="btn-wrapper btn-wrapper__red" @click="submit()">
            Submit
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  data() {
    return {
      bisnis_unit: 0,
      vendors: [],
      gems: [],
      bc: [],
      bkes: [],
      files: [],
      choosedGems: '',
      choosedBc: '',
      choosedBkes: '',
      note: '',
      gemsReady: false,
      bceReady: false,
      bkesReady: false,
    }
  },
  mounted() {
    if (this.$store.state.myRequest.isExtend) {
      this.getVendorMounted(this.$store.state.myRequest.nama_vendor)
    }
  },
  computed: {
    choosedVendor: {
      get() {
        return this.$store.state.myRequest.choosedVendor
      },
      set(newValue) {
        this.$store.commit('myRequest/SET_DATA', {
          name: 'choosedVendor',
          value: newValue,
        })
      },
    },
    choosedBisnis: {
      get: function() {
        return this.bisnis_unit
      },
      set: function(newValue) {
        let company = ''

        if (newValue == 2) company = 'gems'
        if (newValue == 1) company = 'bc'
        if (newValue == 3) company = 'bkes'

        this.companyCode(company)
        this.bisnis_unit = newValue
      },
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.choosedVendor, 'Nama Vendor'],
        [this.bisnis_unit, 'Bisnis Unit'],
        [this.files.length > 0, 'Lampiran'],
      ]

      if (this.bisnis_unit == 2) {
        arr = [...arr, [this.choosedGems, 'Detail Company GEMS']]
      }
      if (this.bisnis_unit == 1) {
        arr = [...arr, [this.choosedBc, 'Detail Company BCE']]
      }
      if (this.bisnis_unit == 3) {
        arr = [...arr, [this.choosedBkes, 'Detail Company BKES']]
      }

      return this.multiConditions(arr)
    },
    submit() {
      let code = ''

      if (this.bisnis_unit == 2) code = this.choosedGems
      if (this.bisnis_unit == 1) code = this.choosedBc
      if (this.bisnis_unit == 3) code = this.choosedBkes

      if (this.checkForm()) {
        this.$store.dispatch('myRequest/createRequest', {
          type: '3',
          vendor: this.choosedVendor.id,
          bisnis_unit: this.bisnis_unit,
          company_code: code,
          note: this.note,
          lampiran: this.files && this.files.length > 0 && this.files[0],
        })
      }
    },
    typingVendor(search, loading) {
      if (search.length > 2 && search.length < 4) {
        this.getVendor(search)
      }
    },
    async companyCode(code) {
      this[code] = await this.$companyCode(code)
    },
    async getVendor(search) {
      this.vendors = await this.$vendorName(search)
    },
    async getVendorMounted(search) {
      let vendor = await this.$vendorName(search)
      this.choosedVendor = vendor[0]
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },

    closeModal() {
      this.$store.commit('myRequest/CANCEL_EXTEND')
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalBlockVendor',
        value: false,
      })
    },
  },
}
</script>
